<template>
  <div>
    <div class="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-center" >
      <p class="title is-4 mb-4">Sign Up</p>

      <button href="#/ms/signup/5fc56d4ed3529c000401c165">
        Plan 1
      </button>

      <button href="#/ms/signup/5fc56d4ed3529c000401c165">
        Plan 2
      </button>

      <form ms-signup="true">
        <b-input ms-field="email" v-model="email" autocomplete="email" />
        <b-input ms-field="password" type="password" v-model="password" autocomplete="new-password" password-reveal/>
        <div class="is-flex is-justify-content-center">
          <input class="button" type="submit" value="Sign up" />
        </div>
      </form>
      <div class="is-flex is-flex-direction-column is-align-items-center is-justify-content-center mt-4">
        <p>Already have an account?
          <router-link to="log-in">Login here.</router-link>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Sign-up',
  data () {
    return {
      email: 'spencer.speas@gmail.com',
      password: 'Goldengun551',
    }
  },
}
</script>


<style lang="scss" scoped>

.fullHeight {
    height: 100vh;
}

</style>